import React, { useRef } from 'react';
import Slider from 'react-slick';
import { FaArrowRight, FaDatabase, FaLaptopCode } from 'react-icons/fa';
import { BsArrowRight } from 'react-icons/bs';
import service_bg from "../assets/service-slider-bg.jpg";
import { TbDeviceAnalytics, TbDeviceMobileCode } from 'react-icons/tb';
import { MdOutlineDesignServices } from 'react-icons/md';
import { Link } from 'react-router-dom';

const testimonialList = [
  {
    id: 1,
    title: 'App Development',
    icon:<TbDeviceMobileCode className='w-10 h-10 text-[#4898a5]' />,
    description: ' We create custom, scalable, and user-friendly apps for Android, iOS, and web platforms, designed to meet your business goals with seamless UI/UX',
  },
  {
    id: 2,
    title: 'Web Development',
    icon:<FaLaptopCode className='w-10 h-10 text-[#4898a5]' />,
    description: "From responsive websites to custom web applications, we build high-performing, SEO-optimized, and secure solutions that enhance your online presence",
  },
  {
    id: 3,
    title: 'Graphic Design',
    icon:<MdOutlineDesignServices className='w-10 h-10 text-[#4898a5]' />,
    description: "Our creative team delivers stunning designs, including logos, branding, marketing materials, and digital graphics, ensuring your brand stands out",
  },
  {
    id: 4,
    title: 'DataBase Security',
    icon:<FaDatabase  className='w-10 h-10 text-[#4898a5]' />,
    description: "Protect your critical data with our advanced security solutions, including encryption, access control, monitoring, and regulatory compliance",
  },
  {
    id: 5,
    title: 'Data Analysis',
    icon:<TbDeviceAnalytics  className='w-10 h-10 text-[#4898a5]' />,
    description: "Turn raw data into actionable insights with our data analysis services, including predictive analytics, business intelligence, and customer behavior insights ",
  },
];

const ServiceSliderSection = () => {
  const sliderRef = useRef(null);

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 300,
    slidesToScroll: 1,
    slidesToShow: 4,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  

  return (
    <div
    className=" bg-cover bg-center  text-white"
    style={{
      backgroundImage: `url(${service_bg})`, // Use the imported image here
    }}
  >
     <div className=" flex justify-between  p-6">
  <div className=" mb-4">
    <h3 className="text-[#504e9a] font-semibold mb-4 text-xl sm:text-2xl md:text-xl">IT SERVICES</h3>
    <h1 className="text-4xl sm:text-5xl font-bold text-gray-900">
      We Solve IT Problems With Technology
    </h1>
  </div>
  <div>
    <Link
      to="/our-services"
      className="relative hidden  lg:flex bg-[#504e9a] text-white px-6 py-3 font-semibold rounded-full border-2 border-[#504e9a] overflow-hidden transition-transform duration-300 will-change-transform z-0 items-center justify-center group hover:text-[#504e9a] w-full sm:w-auto"
    >
      Get In Touch
      <FaArrowRight
        className="ml-2 h-4 w-4 transition-transform -rotate-45 duration-300 transform group-hover:rotate-0"
      />
      <span
        className="absolute inset-0 bg-white rounded-full transform -translate-x-full transition-transform duration-300 group-hover:translate-x-0 will-change-transform z-[-1]"
      ></span>
    </Link>
  </div>
</div>

      <Slider ref={sliderRef} {...settings}>
        {testimonialList.map((service,index) => (
         <div key={index} className="px-4 py-8">
      <Link to="/our-services">  
  <div className="bg-white p-8 rounded-xl shadow-sm border transition-all duration-300 group hover:bg-[#504e9a]">
    <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6 transition-all duration-300 group-hover:bg-white group-hover:text-[#4898a5]">
      {service.icon}
    </div>
    <h3 className="text-xl font-bold text-gray-900 mb-4 transition-colors duration-300 group-hover:text-white">
      {service.title}
    </h3>
    <p className="text-gray-600 mb-6 transition-colors duration-300 group-hover:text-white">
      {service.description}
    </p>
    <span
      
      className="inline-flex items-center font-semibold text-gray-600 transition-colors duration-300 group-hover:text-white"
    >
      Read More
      <BsArrowRight className="w-4 h-4 ml-2" />
    </span>
  </div>
  </Link>
</div>

        ))}
      </Slider>
    </div>
  );
};

export default ServiceSliderSection;
